import * as React from 'react';
import jwtDecode from 'jwt-decode';
import queryString from 'query-string';
import { RouteComponentProps, withRouter } from 'react-router';
import { ACCESS_TOKEN, EXPIRES_AT, ID_TOKEN } from '../../constants/authentication';

class ForwardAuthentication extends React.Component<RouteComponentProps<{}>> {
  componentDidMount() {
    const { location, history } = this.props;
    const { pathname, search: searchQeury } = location;
    const { access_token: accessToken, id_token: idToken } = queryString.parse(searchQeury);

    if (accessToken && idToken) {
      const { exp } = jwtDecode<{ exp: number }>(accessToken);
      localStorage.setItem(ACCESS_TOKEN, accessToken);
      localStorage.setItem(ID_TOKEN, idToken);
      localStorage.setItem(EXPIRES_AT, String(exp * 1000));
      history.push(pathname);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(ForwardAuthentication);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ForwardAuthentication/ForwardAuthentication.tsx